import { TypeMerchant, UnitPerPage } from '@constants/transactions';
import * as transactionTypes from './actionTypes';

const initialPagination = {
  currentPage: 1,
  pageTotal: 0,
  perPage: UnitPerPage,
  itemsTotal: 0,
};

const initialFilter = {
  text: null,
  startDate: null,
  endDate: null,
  filterApply: false,
};

export const initialState = {
  merchantType: TypeMerchant.FALABELLA,
  data: [],
  dataRefunds: [],
  pagination: initialPagination,
  filter: initialFilter,

  currentTransaction: {},
  currentRefund: {},
  isLoadingTransactions: true,
  isLoadingExport: false,
  isLoading: false,
  movements: {},
  errorTransactionsDetails: null,
  loadingTransactionsDetails: false,
  transactionReference: null,
  transactionInProgress: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case transactionTypes.SET_TRANSACTION_DATA: {
      return {
        ...state,
        ...action.payload,
        errorTransactions: false,
      };
    }

    case transactionTypes.SET_REFUNDS_TRANSACTION_DATA: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case transactionTypes.SET_CURRENT_TRANSACTION: {
      return {
        ...state,
        currentTransaction: action.payload,
      };
    }

    case transactionTypes.SET_ORIGINAL_TRANSACTION_SALE_AMOUNT: {
      return {
        ...state,
        originalTransactionSaleAmount: action.payload.originalTransactionSaleAmount,
      };
    }

    case transactionTypes.SET_MERCHANT_TYPE: {
      return {
        ...state,
        merchantType: action.payload.merchantType,
      };
    }

    case transactionTypes.SET_CURRENT_REFUND: {
      return {
        ...state,
        currentRefund: { ...action.payload },
      };
    }

    case transactionTypes.INITIAL_PAGINATION: {
      return {
        ...state,
        pagination: initialPagination,
      };
    }

    case transactionTypes.SET_PAGINATION: {
      return {
        ...state,
        pagination: action.payload,
      };
    }

    case transactionTypes.SHOW_LOADING_TRANSACTIONS:
      return {
        ...state,
        isLoadingTransactions: true,
      };

    case transactionTypes.HIDE_LOADING_TRANSACTIONS:
      return {
        ...state,
        isLoadingTransactions: false,
      };

    case transactionTypes.SHOW_LOADING_EXPORT:
      return {
        ...state,
        isLoadingExport: true,
      };

    case transactionTypes.HIDE_LOADING_EXPORT:
      return {
        ...state,
        isLoadingExport: false,
      };

    case transactionTypes.SHOW_LOADING_CURRENT_TRANSACTION:
      return {
        ...state,
        isLoading: true,
      };

    case transactionTypes.HIDE_LOADING_CURRENT_TRANSACTION:
      return {
        ...state,
        isLoading: false,
      };

    case transactionTypes.FETCH_MOVEMENTS: {
      return {
        ...state,
      };
    }

    case transactionTypes.SET_MOVEMENTS: {
      return {
        ...state,
        movements: action.payload,
        errorLastMovements: false,
      };
    }

    case transactionTypes.SET_LAST_MOVEMENTS_ERROR: {
      return {
        ...state,
        errorLastMovements: action.payload.errorLastMovements,
      };
    }

    case transactionTypes.SET_TRANSACTIONS_ERROR: {
      return {
        ...state,
        errorTransactions: action.payload.errorTransactions,
      };
    }

    case transactionTypes.SET_FILTER: {
      return {
        ...state,
        filter: action.payload,
      };
    }

    case transactionTypes.RESET_FILTER: {
      return {
        ...state,
        filter: initialFilter,
      };
    }
    case transactionTypes.DEFAULT_FILTER: {
      return {
        ...state,
        defaultFilter: { ...action.payload, filterApply: false },
      };
    }
    case transactionTypes.SET_TRANSACTION_DETAILS: {
      if (action.payload?.transactionReference === state?.transactionReference) {
        return {
          ...state,
          transactionDetails: {
            ...action.payload,
            data: {
              ...action.payload.data,
              orderSummary:
                state.transactionDetails?.data?.orderSummary?.length > 0
                  ? [
                      ...state.transactionDetails?.data?.orderSummary,
                      ...action.payload.data.orderSummary,
                    ]
                  : action.payload.data.orderSummary,
            },
          },
        };
      }
    }
    case transactionTypes.SET_ERROR_TRANSACTION_DETAILS: {
      return {
        ...state,
        errorTransactionsDetails: action.payload.error,
      };
    }
    case transactionTypes.CLEAR_TRANSACTION_DETAILS: {
      return {
        ...state,
        transactionDetails: null,
        errorTransactionsDetails: null,
        transactionReference: null,
      };
    }
    case transactionTypes.SHOW_LOADING_TRANSACTION_DETAILS: {
      return {
        ...state,
        loadingTransactionsDetails: true,
      };
    }
    case transactionTypes.HIDE_LOADING_TRANSACTION_DETAILS: {
      return {
        ...state,
        loadingTransactionsDetails: false,
      };
    }
    case transactionTypes.SET_TRANSACTION_REFERENCE: {
      return {
        ...state,
        transactionReference: action.payload,
      };
    }
    case transactionTypes.TRANSACTION_IN_PROGRESS:
      return { ...state, transactionInProgress: action.payload };

    default:
      return {
        ...state,
      };
  }
};
